import { useMediaQuery } from '@mui/material';
import { Suspense, useEffect, useState, lazy } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import routes from '../../Utils/Constants/routes';
import { useAuthContext } from '../../Context/authContext';
import { useTheme } from '@emotion/react';
import { TABLET_BREAKPOINT } from '../../Utils/Constants/constant';
import { useAppContext } from '../../Context/appContext';
import { getApplicationsByApplicantId, getAxiosInstance, getAllQueryByApplicantId } from '../../Utils/apiServices';
import { PrivateRouter, PublicRouter } from '../../Utils/Helpers/applicationHelper';
import home from '../../Assets/Icons/home.png';
import allPrograms from '../../Assets/Icons/allPrograms.png';
import myApplications from '../../Assets/Icons/myApplications.png';
import payments from '../../Assets/Icons/payments.png';
import documents from '../../Assets/Icons/documents.png';
import KenLoader from '../../Components/KenLoader';
import homeII from '../../Assets/Icons/home II.png';
import allApplicationII from '../../Assets/Icons/allApplicationII.png';
import myapplicationII from '../../Assets/Icons/myapplication II.png';
import paymentsII from '../../Assets/Icons/payments II.png';
import documentsII from '../../Assets/Icons/documents II.png';
import Raiseaquery from '../../Assets/Icons/Raiseaquery.png';
import RaiseaqueryMobile from '../../Assets/Icons/queryMobile.png';
import { VscBellDot } from "react-icons/vsc";
import NotifyIcon from '../../Assets/Icons/NotifyIcon.svg'
import { useLocation } from 'react-router-dom';

const AppLayout = lazy(() => import('../../Components/AppLayout'));
const HomePage = lazy(() => import('../HomePage'));
const DocumentPage = lazy(() => import('../DocumentPage'));
const Login = lazy(() => import('../Auth/Login'));
const SignUp = lazy(() => import('../Auth/SignUp'));
const Courses = lazy(() => import('../Courses'));
const MyApplications = lazy(() => import('../MyApplications'));
const ApplicationFormNew = lazy(() => import('../ApplicationForm'));
const PaymentHistory = lazy(() => import('../PaymentHistory'));
const LandingPageCommon = lazy(() => import('../../Containers/LandingPageCommonPage'));
const DEMLandingPage = lazy(() => import('../DEMLandingPage/index.js'));
const GSCMLandingPage = lazy(() => import('../GSCMLandingPage/index.js'));
const Faq = lazy(() => import('../FAQ'));
const CourseEligibility = lazy(() => import('../CourseEligibility'));
const ThankyouScreen = lazy(() => import('../Auth/ThankyouForRegistering'));
const ConfirmingEmail = lazy(() => import('../Auth/ConfirmingEmail'));
const ResetPassword = lazy(() => import('../Auth/ResetPassword'));
const ResetPasswordMain = lazy(() => import('../Auth/ResetPasswordMain'));
const QueryHistory = lazy(() => import('../../Containers/RaiseaQuery/Components/QueryHistory'));
const QueryOverview = lazy(() => import('../../Containers/RaiseaQuery/Components/ReviewRequest'));
const EMBALandingPage = lazy(() => import('../EMBALandingPage/index.js'));
const SPMLandingPage = lazy(() => import('../SPMLandingPage/index.js'));
const PhDLandingPage = lazy(() => import('../PhDLandingPage/index.js'));
const EphdLandingPage = lazy(()=> import('../EphdLandingPage/index.js') );
const TwoyearmbaInternationallandingpage = lazy(()=> import('../TwoyearmbaInternationallandingpage/index.js'))
const CommonInternationalLandingPage = lazy(()=> import('../CommonInternationalLandingPage/index.js'))
const StudentInterviewModule = lazy(() => import('../studentInterviewModule/index.js'));
const InterviewBookslotTab = lazy(() => import('../studentInterviewModule/Components/InterviewBookslotTab/index.jsx'));

export default function MainLayout(props) {
  const theme = useTheme();
  const isMobileScreen = useMediaQuery(theme.breakpoints.down(TABLET_BREAKPOINT));
  const {
    state: { isLoading = false },
  } = useAppContext();
  const {
    state: { user },
  } = useAuthContext();
  const [publishedCount, setPublishedCount] = useState(0);
  const location = useLocation();
  const fetchQueries = async () => {
    try {
      if (!user?.applicantId) return;

      const response = await getAllQueryByApplicantId(user.applicantId);
      console.log('Query Response:', response);

      let count = 0;
      response.forEach(item => {
        const comments = item.comments;
        if (Array.isArray(comments)) {
          const published = comments.filter(comment =>comment?.createdByName !=='Application Portal Integration User' && comment?.isPublished === true);
          count += published.length;
        }
      });

      setPublishedCount(count);
      console.log('Total published comments:', count);
    } catch (error) {
      console.error('Error fetching queries:', error);
    }
  };

  useEffect(() => {
    fetchQueries();
  }, [user?.applicantId]);

  useEffect(() => {
    if (location.pathname === routes.queryView) {
      fetchQueries();
    }
  }, [location.pathname]);

  const menu = [
    {
      icon: home,
      mobileIcon: homeII,
      label: 'Home',
      link: routes.home,
      callback: '',
    },

    {
      icon: allPrograms,
      mobileIcon: allApplicationII,
      label: 'All Programs',
      link: routes.courses,
      callback: '',
    },
    {
      icon: myApplications,
      mobileIcon: myapplicationII,
      label: 'My Applications',
      link: routes.myApplications,
      callback: '',
    },
    {
      icon: Raiseaquery,
      mobileIcon: RaiseaqueryMobile,
      label: (
        <>
          <span style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            Raise a query
      {publishedCount > 0 && (
          <img
            src={NotifyIcon}
            alt="Notify Icon"
            style={{ width: '18px', height: '18px' }}
          />
        )}
          </span>
        </>
      ),
      link: routes.queryHistory,
      callback: '',
    },
  ];

  const [sideNavMenu, setSideNavMenu] = useState(menu);

  getAxiosInstance();

  useEffect(() => {
    setSideNavMenu(menu);
  }, [publishedCount]);
  // useEffect(() => {
  //   setSideNavMenu(menu);
  // }, [menu]);
  useEffect(() => {
    if (user?.applicantId) {
      getApplicationsByApplicantId(user?.applicantId).then((res) => {
        const tempData = [...sideNavMenu];
        if ((res?.data || 0)?.length > 0) {
          if (sideNavMenu?.filter((s) => s.label === 'Payments')?.length === 0) {
            tempData.push({
              icon: payments,
              mobileIcon: paymentsII,
              label: 'Payments',
              link: routes.feePaymentHistory,
              callback: '',
            });
          }

          if (sideNavMenu?.filter((s) => s.label === 'Documents')?.length === 0) {
            tempData.push({
              icon: documents,
              mobileIcon: documentsII,
              label: 'Documents',
              link: routes.document,
              callback: '',
            });
          }

          const hasInterview = res?.data?.some((item) => item?.hed__Application_Status__c === 'Interview');


          if (hasInterview && sideNavMenu?.filter((s) => s.label === 'Interview')?.length === 0) {
            tempData.push({
              icon: home,
              mobileIcon: homeII,
              label: 'Interview',
              link: routes.studentInterviewTab,
              callback: '',
            });
          }
          
          setSideNavMenu([...tempData]);
        }
      });
    }
  }, [isMobileScreen, user?.applicantId, location.pathname, location.key]);

  

  return (
    <>
      {/* {isLoading && <KenLoader />} */}
      <Suspense>
        <Routes>
          <Route path={`*`} element={<Navigate to={routes.landingPage} />} />
          {/* Public Router */}
          <Route path={routes.verify} element={<ConfirmingEmail />} />
          <Route
            exact
            path={`/`}
            element={
              <PublicRouter>
                <LandingPageCommon />
              </PublicRouter>
            }
          />
          <Route
            path={routes.demlandingpage}
            element={
              <PublicRouter>
                <DEMLandingPage />
              </PublicRouter>
            }
          />
          <Route
            path={routes.gscmlandingpage}
            element={
              <PublicRouter>
                <GSCMLandingPage />
              </PublicRouter>
            }
          />
          <Route
            path={routes.embalandingpage}
            element={
              <PublicRouter>
                <EMBALandingPage />
              </PublicRouter>
            }
          />
           <Route
            path={routes.spmlandingpage}
            element={
              <PublicRouter>
                <SPMLandingPage />
              </PublicRouter>
            }
          />
          <Route
            path={routes.phdlandingpage}
            element={
              <PublicRouter>
                <PhDLandingPage />
              </PublicRouter>
            }
          />
           <Route
            caseSensitive
            path={routes.ephdlandingpage}
            element={
              <PublicRouter>
                <EphdLandingPage/>
              </PublicRouter>
            }
          />
                   <Route
          caseSensitive
          path={routes.twoyearmbaInternationallandingpage}
          element={
            <PublicRouter>
              <TwoyearmbaInternationallandingpage />
            </PublicRouter>
          }
        />
         <Route
          caseSensitive
          path={routes.commonInternationalLandingPage}
          element={
            <PublicRouter>
              <CommonInternationalLandingPage />
            </PublicRouter>
          }
        />
          <Route
            path={routes.login}
            element={
              <PublicRouter>
                <Login />
              </PublicRouter>
            }
          />
          <Route
            path={routes.signup}
            element={
              <PublicRouter>
                <SignUp />
              </PublicRouter>
            }
          />
          <Route
            path={routes.success}
            element={
              <PublicRouter>
                <ThankyouScreen />
              </PublicRouter>
            }
          />
          <Route
            path={routes.resetpassword}
            element={
              <PublicRouter>
                <ResetPassword />
              </PublicRouter>
            }
          />
          <Route
            path={routes.resendVerification}
            element={
              <PublicRouter>
                <ResetPassword />
              </PublicRouter>
            }
          />
          <Route
            path={routes.resetPasswordMain}
            element={
              <AppLayout sideNavMenu={sideNavMenu}>
                <ResetPasswordMain />
              </AppLayout>
            }
          />

          {/* Private Router */}
          <Route
            path={routes.applicationForm}
            element={
              <PrivateRouter>
                {isMobileScreen ? (
                  <AppLayout sideNavMenu={sideNavMenu}>
                    <ApplicationFormNew />
                  </AppLayout>
                ) : (
                  <ApplicationFormNew />
                )}
              </PrivateRouter>
            }
          />

          {/* Layout Routes */}
          <Route path="app" element={<AppLayout sideNavMenu={sideNavMenu} />}>
            <Route
              path={'home'}
              index
              element={
                <PrivateRouter>
                  <HomePage />
                </PrivateRouter>
              }
            />
            <Route
              path={'document'}
              element={
                <PrivateRouter>
                  <DocumentPage />
                </PrivateRouter>
              }
            />
            <Route
              path={`paymentHistory`}
              element={
                <PrivateRouter>
                  <PaymentHistory />
                </PrivateRouter>
              }
            />
            <Route
              path={`faq`}
              element={
                <PrivateRouter>
                  <Faq />
                </PrivateRouter>
              }
            />
            <Route
              path={'courses'}
              element={
                <PrivateRouter>
                  <Courses />
                </PrivateRouter>
              }
            />
            <Route
              path={'my-applications'}
              element={
                <PrivateRouter>
                  <MyApplications />
                </PrivateRouter>
              }
            />
            <Route
              path={'eligibility'}
              element={
                <PrivateRouter>
                  <CourseEligibility />
                </PrivateRouter>
              }
            />
            <Route
              path={'queryHistory'}
              element={
                <PrivateRouter>
                  <QueryHistory />
                </PrivateRouter>
              }
            />
            <Route
              path={'queryView'}
              element={
                <PrivateRouter>
                  <QueryOverview />
                </PrivateRouter>
              }
            />
            <Route
            caseSensitive
            path={'studentInterviewTab'}
            element={
              <PrivateRouter>
                <StudentInterviewModule />
              </PrivateRouter>
            }
          />
          <Route
            caseSensitive
            path={'slotInterviewBooking'}
            element={
              <PrivateRouter>
                <InterviewBookslotTab />
              </PrivateRouter>
            }
          />
          </Route>
        </Routes>
      </Suspense>
    </>
  );
}
